import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=5769dee6&scoped=true&"
import script from "./Consent.vue?vue&type=script&lang=js&"
export * from "./Consent.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/authen.css?vue&type=style&index=0&id=5769dee6&scoped=true&lang=css&"
import style1 from "./Consent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5769dee6",
  null
  
)

export default component.exports